import { useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import AnimatedLoader from '../../AnimatedLoader'
import CheckNoBg from '../../Icons/CheckNoBg'

const morph = keyframes`
    0%{
        transform: scale(1,1);
    }
    50%{
        transform: scale(2, 1);
    }
    100%{
        transform: scale(1,1);
    }
`

const fadeIn = keyframes`
    0%{
        opacity:0;
    }
    100%{
        opacity:1;
    }
`

const SwitchBackground = styled.div<{ active: boolean; disabled: boolean }>`
  position: relative;
  width: 56px;
  height: 28px;
  background: var(--surface-minimal-primary, rgba(255, 255, 255, 0.06));
  border: 1px solid ${({ active }) => (active ? '#FDFD0F' : '#2b363c')};
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  overflow: hidden;
  :hover {
    filter: brightness(1.2);
  }
  .checkmark {
    opacity: 0;
    position: absolute;
    right: 4px;
    top: 4px;
    animation: ${fadeIn} 0.6s linear forwards;
    pointer-events: none;
  }
  .loading-spinner {
    position: absolute;
    ${({ active }) => (active ? 'right' : 'left')}: 7px;
    top: 7px;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`

const SwitchInner = styled.div<{ active: boolean; shouldAnimate: boolean }>`
  position: absolute;
  min-width: 54px;
  min-height: 24px;
  max-width: 54px;
  max-height: 24px;
  border-radius: 50px;
  top: 1px;
  left: 2px;
  overflow: hidden;
  transition: 0.3s ease-in-out;
  &:before {
    content: '';
    position: absolute;
    right: ${({ active }) => (active ? 4 : 32)}px;
    width: 22px;
    height: 22px;
    top: 1px;
    background-color: ${({ active }) => (active ? '#FDFD0F' : '#ffffff')};
    border-radius: 50%;
    transition: 0.3s ease-in-out;
  }
  &:after {
    content: '';
    position: absolute;
    right: ${({ active }) => (active ? 4 : 32)}px;
    width: 22px;
    height: 22px;
    top: 1px;
    background-color: ${({ active }) => (active ? '#FDFD0F' : '#ffffff')};
    border-radius: 50%;
    transition: 0.3s ease-in-out;
    ${({ shouldAnimate }) =>
      shouldAnimate &&
      css`
        animation: ${morph} 0.3s infinite;
      `}
  }
`

const Switch = ({
  checked,
  onChange,
  disabled,
  isLoading,
}: {
  checked: boolean
  onChange: (v: boolean) => void
  disabled?: boolean
  isLoading?: boolean
}) => {
  const [shouldAnimate, setShouldAnimate] = useState(false)
  function clickHandler() {
    if (disabled) return
    setShouldAnimate(true)
    onChange(!checked)
    setTimeout(() => setShouldAnimate(false), 300)
  }
  return (
    <SwitchBackground
      onClick={clickHandler}
      active={checked}
      disabled={!!disabled}
    >
      <SwitchInner active={checked} shouldAnimate={shouldAnimate}></SwitchInner>
      {isLoading && (
        <div className="loading-spinner">
          <AnimatedLoader size={12} />
        </div>
      )}
      {checked && !isLoading && <CheckNoBg size={20} className="checkmark" />}
    </SwitchBackground>
  )
}

export default Switch
